import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";

export const resetUserPassword = createAsyncThunk(
  "resetUserPassword",
  async (username) => {
    const payload = {
      username: username,
    };

    const response = await FetchRequestHandler(
      "post",
      `${baseUrl}api/users/reset-password`,
      payload
    );
    return response.data;
  }
);

export const fetchUsers = createAsyncThunk(
  "fetchUsers",
  async ({
    searchString = "",
    roles = [],
    status = "true",
    pageNumber = 1,
    pageSize = 10,
  } = {}) => {
    let url = `${baseUrl}api/users?`;
    const params = [];

    if (status !== "all") {
      const formattedStatus =
        status === "enabled" || status === "true" ? "true" : "false";
      params.push(`filter-properties=enabled`);
      params.push(`filter-values=${formattedStatus}`);
    }

    params.push(`page-number=${pageNumber}`);
    params.push(`page-size=${pageSize}`);

    if (searchString) {
      params.push(`search-string=${searchString}`);
    }

    if (roles && roles.length > 0) {
      const mappedRoles = roles.map((role) => {
        if (role === "ROLE_ADMINISTRATOR") return "ROLE_ADMIN";
        return role;
      });

      mappedRoles.forEach(() => {
        params.push(`filter-properties=user-role`);
      });

      mappedRoles.forEach((role) => {
        params.push(`filter-values=${role}`);
      });
    }

    url += params.join("&");

    const response = await FetchRequestHandler("get", url);
    return {
      data: response.data,
      filters: { searchString, roles, status, pageNumber, pageSize },
    };
  }
);

export const createUser = createAsyncThunk("createUser", async (userData) => {
  console.log("createUser userData:", userData);

  const payload = {
    firstName: userData.firstName,
    lastName: userData.lastName,
    username: userData.username,
    enabled: true,
    confirmed: false,
    assignAppointments: false,
    grantedRoles:
      userData.role && Array.isArray(userData.role)
        ? userData.role.map((role) => {
            if (role === "ROLE_ADMINISTRATOR") return "ROLE_ADMIN";
            return role.startsWith("ROLE_") ? role : `ROLE_${role}`;
          })
        : userData.role === "ROLE_ADMINISTRATOR"
        ? ["ROLE_ADMIN"]
        : userData.role
        ? [`ROLE_${userData.role}`]
        : userData.grantedRoles || [],
  };

  console.log("createUser payload:", payload);

  const response = await FetchRequestHandler(
    "post",
    `${baseUrl}api/users/create-new`,
    payload
  );
  return response.data;
});

export const updateUser = createAsyncThunk("updateUser", async (userData) => {
  const payload = {
    displayId: userData.displayId,
    firstName: userData.firstName,
    lastName: userData.lastName,
    username: userData.username,
    enabled: userData.enabled,
    confirmed: userData.confirmed || "false",
    assignAppointments: userData.assignAppointments || "false",
    practices: [
      {
        kokoPracticeRef: "FRIPISVE86895915",
        name: "Afton Family Dental PC",
      },
    ],
    grantedRoles: Array.isArray(userData.role)
      ? userData.role.map((role) => {
          if (role === "ROLE_ADMINISTRATOR") return "ROLE_ADMIN";
          return role.startsWith("ROLE_") ? role : `ROLE_${role}`;
        })
      : userData.role === "ROLE_ADMINISTRATOR"
      ? ["ROLE_ADMIN"]
      : userData.role
      ? [`ROLE_${userData.role}`]
      : userData.grantedRoles
      ? Array.isArray(userData.grantedRoles)
        ? userData.grantedRoles
        : userData.grantedRoles.split(",").map((role) => role.trim())
      : [],
    originalUsername: userData.originalUsername || userData.username,
  };

  const response = await FetchRequestHandler(
    "put",
    `${baseUrl}api/users/${userData.displayId}/update`,
    payload
  );
  return response.data;
});
